































import { Component, Vue } from 'vue-property-decorator';
import { yunnanDataViewServer } from '@/api/installServer';
import ListDialog from '../../yunnanDataView/unit/box8/box-8-unit-1.vue';
import dayJs from 'dayjs';

@Component({
  components: { ListDialog },
})
export default class DataBox4 extends Vue {
  private $echarts: any;
  private dataForm: any = {};
  private chartType: any = '';
  private topDeptId: any = '';
  private topDataNumObj: any = {
    thisMonthFind: 0,
    thisWeekFind: 0,
    todayFind: 0,
  };

  mounted() {
    // this.getData({});
  }

  goList(type: any) {
    // 列表弹框
    let startTime: any = '';
    let endTime: any = '';
    switch (type) {
      case 'month':
        startTime =
          dayJs()
            .startOf('month')
            .format('YYYY-MM-DD') + ' 00:00:00';
        endTime =
          dayJs()
            .endOf('month')
            .format('YYYY-MM-DD') + ' 23:59:59';
        break;
      case 'week':
        const week = 0;
        const dateCurrent: any = new Date();
        const timestamp = Math.round(dateCurrent);
        const date = new Date(timestamp);
        const weekday = date.getDay();
        const we = weekday === 0 ? week - 1 : week;

        startTime = dayJs()
          .add(we, 'week')
          .startOf('week')
          .add(1, 'day')
          .format('YYYY-MM-DD 00:00:00');

        endTime = dayJs()
          .add(we, 'week')
          .endOf('week')
          .add(1, 'day')
          .format('YYYY-MM-DD 23:59:59');
        break;
      case 'day':
        startTime = dayJs(new Date()).format('YYYY-MM-DD') + ' 00:00:00';
        endTime = dayJs(new Date()).format('YYYY-MM-DD') + ' 23:59:59';
        break;
    }
    const ref: any = this.$refs['ListDialogRef'];
    const data: any = {
      // type: type,
      startTime: startTime,
      endTime: endTime,
      deptId: this.topDeptId || null,
    };
    console.log(data);
    ref.showDialog(data);
  }

  getData(opts: any) {
    this.topDeptId = opts.topDeptId || '';
    yunnanDataViewServer
      .getCheckCollect({
        topDeptId: opts.topDeptId || null,
      })
      .then((res: any) => {
        this.topDataNumObj = res.data;
      })
      .catch((e: any) => {
        console.log(e);
      });
    this.getChartData('week');
  }

  getChartData(type: any) {
    const map: any = {
      day: 'CURRENT_DAY',
      week: 'CURRENT_WEEK',
      month: 'CURRENT_MONTH',
    };

    const form: any = {
      dateRangeType: map[type],
      topDeptId: this.topDeptId,
    };

    yunnanDataViewServer
      .getCheckDayDistributed(form)
      .then((res: any) => {
        this.dataForm = res.data;
        this.chartType = type;
        this.showCharts();
      })
      .catch((e: any) => {
        console.log(e);
      });
  }

  private showCharts() {
    const nameArr: any = [];
    const valueArr2: any = [];
    this.dataForm['安全检查'].forEach((item: any) => {
      valueArr2.push(item.yaxis); // 发现隐患
    });

    const dataZoomMap: any = {
      day: [0, 100],
      week: [0, 100],
      month: [0, 20],
    };

    const echartsA = this.$echarts.init(document.getElementById('house-charts-8-1') as any);
    const optionA = {
      title: {
        text: '',
        subtext: '',
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
      },
      legend: {
        // data: ['风险随查', '安全检查', '发现隐患'],
        data: ['监督检查'],
        x: 'right',
        y: 'top',
        textStyle: {
          fontSize: 10, //字体大小
          color: '#999', //字体颜色
        },
        itemWidth: 10, // 设置宽度
        itemHeight: 10, // 设置高度
        itemGap: 10, // 设置间距
      },
      grid: {
        left: '4%',
        right: '4%',
        bottom: '20%',
        top: '18%',
        containLabel: true,
      },
      yAxis: [
        {
          type: 'value',
          minInterval: 1,
          axisLabel: {
            formatter: function(i: any) {
              const l = (3 - i.toString().length) * 2 + 1;
              const r = i + Array(l).join('\ ');
              return r;
            },
            textStyle: {
              color: '#888',
              fontSize: 11,
            },
          },
          splitLine: {
            lineStyle: {
              color: '#ccc',
              type: 'dashed',
            },
          },
          boundaryGap: [0, 0.01],
          axisLine: {
            //y轴
            show: false,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
        },
      ],
      xAxis: {
        triggerEvent: true,
        data: nameArr,
        axisLine: {
          show: false,
        },
        splitLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          textStyle: {
            color: '#888',
            fontSize: 10,
          },
        },
      },
      dataZoom: [
        {
          type: 'slider',
          id: 'heng',
          xAxisIndex: [0],
          filterMode: 'none', // 当前数据窗口外的数据，被 过滤掉。即 会 影响其他轴的数据范围。每个数据项，只要有一个维度在数据窗口外，整个数据项就会被过滤掉。
          start: dataZoomMap[this.chartType][0], // 显示0% 开始的数据， 到 10%的数据结束，相当展示前10%的数据，做到降采样
          end: dataZoomMap[this.chartType][1],
          bottom: '12%',
          left: '6%',
          right: '6%',
          height: 4,
          handleSize: '400%',
          handleStyle: {
            color: '#73a0fa',
          },
          borderColor: 'transparent',
          backgroundColor: 'rgba(0,0,0,0.04)',
          dataBackground: {
            lineStyle: {
              opacity: 0,
            },
            areaStyle: {
              opacity: 0,
            },
          },
          fillerColor: '#73a0fa',
          textStyle: {
            color: 'transparent',
          },
        },
      ],
      series: [
        /*{
            name: '风险随查',
            type: 'bar',
            barWidth: 8,
            data: valueArr3,
            color: '#0091FF',
            itemStyle: {
              normal: {
                barBorderRadius: 8,
                label: {
                  show: false, //开启显示
                  position: 'top', //在上方显示
                  textStyle: {
                    //数值样式
                    color: '#999',
                    fontSize: 14,
                    fontWeight: 600,
                  },
                },
              },
            },
          },*/
        {
          name: '监督检查',
          type: 'bar',
          barWidth: 8,
          data: valueArr2,
          color: 'rgba(19,188,255,0.9)',
          // color:'#13BCFF',
          itemStyle: {
            normal: {
              barBorderRadius: 8,
              label: {
                show: false, //开启显示
                position: 'top', //在上方显示
                textStyle: {
                  //数值样式
                  color: '#999',
                  fontSize: 14,
                  fontWeight: 600,
                },
              },
            },
          },
        },
        /*{
            name: '发现隐患',
            type: 'bar',
            barWidth: 8,
            data: valueArr1,
            color: '#FF6262',
            itemStyle: {
              normal: {
                barBorderRadius: 8,
                label: {
                  show: false, //开启显示
                  position: 'top', //在上方显示
                  textStyle: {
                    //数值样式
                    color: '#999',
                    fontSize: 14,
                    fontWeight: 600,
                  },
                },
              },
            },
          },*/
      ],
    };

    echartsA.setOption(optionA);
  }
}
